import { getAPIFullUrl, getAxiosConfig, handleApiError } from './risapi';
import { risapi } from './risapi';

export const getPurchaseReturns = async (filterParameters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/purchase-returns', filterParameters), getAxiosConfig());
        if (response.status === 200) callback(response.data);
    } catch (error) { handleApiError(error); callback({ error }); }
};

export const fetchPurchaseReturn = async (id, callback) => {
    try {
        const response = await risapi.get(`/api/purchase-returns/${id}`, getAxiosConfig());
        if (response.status === 200) callback(response.data);
    } catch (error) { handleApiError(error); callback({ error }); }
};

export const createPurchaseReturn = async (newData, callback) => {
    try {
        const response = await risapi.post('/api/purchase-returns', newData, getAxiosConfig());
        if (response.status === 201) callback(response.data);
    } catch (error) { callback({ error }); }
};

// ** ADDED MISSING UPDATE FUNCTION **
export const updatePurchaseReturn = async (id, updateData, callback) => {
    try {
        const response = await risapi.put(`/api/purchase-returns/${id}`, updateData, getAxiosConfig());
        if (response.status === 200) callback(response.data);
    } catch (error) { callback({ error }); }
};

// ** ADDED MISSING DELETE FUNCTION **
export const destroyPurchaseReturn = async (id, callback) => {
    try {
        const response = await risapi.delete(`/api/purchase-returns/${id}`, getAxiosConfig());
        if (response.status === 204) callback({ success: true });
    } catch (error) { callback({ error }); }
};

export const getPurchaseInvoicesForReturn = async (partyId, callback) => {
    try {
        const response = await risapi.get(`/api/purchase-invoices?party_id=${partyId}&nopaginate=true`, getAxiosConfig());
        if (response.status === 200) {
             const data = response.data.purchase_invoices?.data || response.data.purchase_invoices || [];
             callback(data);
        }
    } catch (error) { handleApiError(error); callback({ error }); }
};

export const getPurchaseReturnPrepopulation = async (invoiceId, callback) => {
    try {
        const response = await risapi.get(`/api/purchase-returns/create?source_invoice_id=${invoiceId}`, getAxiosConfig());
        if (response.status === 200) callback(response.data);
    } catch (error) { callback({ error: error.response?.data || { message: 'Error fetching invoice details.' } }); }
};